<template>
  <div style="position: fixed; top: 0; left: -100000px; width: 1000px">
    <div id="final-statement-paper">
      <div class="page" v-for="item, index in data" :key="index">
        <table>
          <thead>
            <tr>
              <th>结算状态</th>
              <th>申请日期</th>
              <th>结算单号</th>
              <th>业务区域</th>
              <th>结算日期</th>
              <th>负责人</th>
              <th>商家</th>
              <th>别名</th>
              <th>收款人</th>
              <th>银行账号</th>
              <th>SWIFT CODE</th>
              <th>币种</th>
              <th>金额</th>
              <th>付款用途</th>
              <th>账期</th>
              <th>是否使用结算币别</th>
              <th>境内/境外</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ item.settleStatus }}</td>
              <td>{{ item.applyTime }}</td>
              <td>{{ item.identifiersNo }}</td>
              <td>{{ item.businessReginName }}</td>
              <td>{{ item.settledAt }}</td>
              <td>{{ item.assistantName }}</td>
              <td>{{ item.vendorRealName }}</td>
              <td>{{ item.vendorName }}</td>
              <td>{{ item.payeeName }}</td>
              <td>{{ item.bankNo }}</td>
              <td>{{ item.swiftCode }}</td>
              <td>{{ item.vendorCurrency }}</td>
              <td>{{ item.amount }}</td>
              <td>{{ item.paymentPurpose }}</td>
              <td>{{ item.settlementCycle }}</td>
              <td>{{ item.useSettleCurrency }}</td>
              <td>{{ item.receivePayType }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import printJS from 'print-js';

export default {
  name: 'FinalStatementPaper',
  props: {
    data: Array,
  },
  methods: {
    print() {
      const that = this;
      printJS({
        printable: 'final-statement-paper',
        type: 'html',
        style: `
                @page {
                  margin: 5mm;
                }
                * { margin: 0; padding: 0 }
                body { color: #000 }
                .page { page-break-before: auto; page-break-after: always; }
                .table {
                  width: 100%;
                  border-collapse:collapse;
                }
                .cell {
                  font-size: 10px;
                }
                table {
                  width: 100%;
                }
                th {
                  background-color: #ccc;
                }
                table, th, td {
                  font-size: 10px;
                  text-align: center;
                  border: 1px solid black;
                  border-collapse: collapse; /* 移除单元格之间的间隔 */
                }
                .table td,
                .table th{
                  padding: 5pt;
                  vertical-align: top;
                  text-align: left;
                }
                .table td.nopadding { padding: 0 }
                .table td.vab { vertical-align: bottom; }
                .bt { border-top: 1pt solid #ccc }
                .bb { border-bottom: 1pt solid #ccc }
                .f10 { font-size: 10pt; font-weight: 300 }
                .f12 { font-size: 12pt }
                .f14 { font-size: 14pt }
                .f16 { font-size: 16pt }
                .f18 { font-size: 18pt }
                .bold { font-weight: bold }
                .txtc { text-align: center }
                .txtr { text-align: right }
                .title { padding: 40pt 80pt 20pt }
                .mt2 { margin-top: 2pt }
                .mt5 { margin-top: 5pt }
                .mt10 { margin-top: 10pt }
                .mt20 { margin-top: 20pt }
                .pl10 { padding-left: 10pt }
                .pr10 { padding-right: 10pt }
                .pl5 { padding-left: 5pt }
                .pr5 { padding-right: 5pt }
                .pt20 { padding-top: 20pt }
                .pb20 { padding-bottom: 20pt }
                .pt10 { padding-top: 10pt }
                .pb10 { padding-bottom: 10pt }
                .pt5 { padding-top: 5pt }
                .pb5 { padding-bottom: 5pt }
                .flex {
                  display: flex;
                  justify-content: space-between;
                }
                .flex-alc { align-items: center; }
                .value {
                  display: inline-block;
                  width: 150pt;
                }
              `,
        // maxWidth: 800,
        onPrintDialogClose: () => {
          that.$emit('close');
        },
        targetStyle: [],
        targetStyles: [],
        font_size: 'auto',
        // ignoreElements: [],
        font: 'Roboto, Arial',
        // honorMarginPadding: false,
        imageStyle: 'max-width: 100%;max-height: 200pt',
      });
    },
  },
};
</script>
